import PageTypeFactory from '../../page/get_page_type';
import GA_EVENTS from './ga_constants';
import { setBehaviourEvent } from './ga_interface';

function close() {
    const category = GA_EVENTS.driverReviewInfoLightBox.category;
    const action = GA_EVENTS.driverReviewInfoLightBox.actions.close;
    const label = PageTypeFactory.getPageType();

    setBehaviourEvent({ category, action, label });
}

function open(from) {
    const category = GA_EVENTS.driverReviewInfoLightBox.category;
    const action = GA_EVENTS.driverReviewInfoLightBox.actions.open;
    const label = `Opened from within ${from}`;

    setBehaviourEvent({ category, action, label });
}

export {
    close,
    open
};
